import React, { useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";

export const usePhonePePay = (data) => {


    const shurjoPayData = data;
    const [phonePeBuffer, setPhonePeBuffer] = useState(false)
    let history = useHistory()


    const phonePePayMakePayment = () => {
        setPhonePeBuffer(true)

        axios.post("/api/init-phonePe", shurjoPayData).then(async (res) => {
            setPhonePeBuffer(false)

            setTimeout(() => {
                window.location.href  = res?.data?.data
            }, 1500);

            // history.push({
            //     pathname:  '/sslCommerz-pay',
            //     state: {
            //         url: res?.data?.data
            //     }// your data array of objects
            // })
        }).catch(err => {
            setPhonePeBuffer(false)
        });


    }

    return { phonePePayMakePayment, phonePeBuffer }
}
